module.exports = __webpack_public_path__ + "static/betters-image-d02d6e7bf5aa5267f4e948c4a021394e.png";